import Vue from 'vue'
import _ from 'lodash'
import { createHelpers } from 'vuex-map-fields'

import {
  // GET_PAYMENT_INFORMATION
  GET_PAYMENT_INFORMATION_REQUEST,
  GET_PAYMENT_INFORMATION_SUCCESS,
  GET_PAYMENT_INFORMATION_FAILURE,

  // PAY_VIA_BILL_PAYMENT
  PAY_VIA_BILL_PAYMENT_REQUEST,
  PAY_VIA_BILL_PAYMENT_SUCCESS,
  PAY_VIA_BILL_PAYMENT_FAILURE,

  // PAY_VIA_CREDIT_CARD
  PAY_VIA_CREDIT_CARD_REQUEST,
  PAY_VIA_CREDIT_CARD_SUCCESS,
  PAY_VIA_CREDIT_CARD_FAILURE,

  // PAY_VIA_QR_CODE
  PAY_VIA_QR_CODE_REQUEST,
  PAY_VIA_QR_CODE_SUCCESS,
  PAY_VIA_QR_CODE_FAILURE,

  // QR_VERIFY_SLIP
  QR_VERIFY_SLIP_REQUEST,
  QR_VERIFY_SLIP_SUCCESS,
  QR_VERIFY_SLIP_FAILURE,
} from '@/lib/mutationTypes'
import router from '@/router'
import API, { HOMEPAGE_URL } from '@/lib/api'
import { generateAuthorizationRequestHeader } from '@/lib/services'

const { getPaymentFields, updatePaymentFields } = createHelpers({
  getterType: 'getPaymentFields',
  mutationType: 'updatePaymentFields',
})

const state = {
  paymentInformation: {
    data: null,
    isLoading: false,
    isError: false,
  },
  billPayment: {
    data: null,
    isLoading: false,
    isError: false,
  },
  creditCard: {
    isLoading: false,
    isError: false,
  },
  qrcode: {
    data: null,
    isLoading: false,
    isError: false,
  },
}

const mutations = {
  // GET_PAYMENT_INFORMATION
  [GET_PAYMENT_INFORMATION_REQUEST](state) {
    state.paymentInformation.isLoading = true
    state.paymentInformation.isError = false
  },
  [GET_PAYMENT_INFORMATION_SUCCESS](state, data) {
    state.paymentInformation.data = data
    state.paymentInformation.isLoading = false
    state.paymentInformation.isError = false
  },
  [GET_PAYMENT_INFORMATION_FAILURE](state) {
    state.paymentInformation.isLoading = false
    state.paymentInformation.isError = true
  },

  // PAY_VIA_BILL_PAYMENT
  [PAY_VIA_BILL_PAYMENT_REQUEST](state) {
    state.billPayment.isLoading = true
    state.billPayment.isError = false
  },
  [PAY_VIA_BILL_PAYMENT_SUCCESS](state, data) {
    state.billPayment.data = data
    state.billPayment.isLoading = false
    state.billPayment.isError = false
  },
  [PAY_VIA_BILL_PAYMENT_FAILURE](state) {
    state.billPayment.isLoading = false
    state.billPayment.isError = true
  },

  // PAY_VIA_CREDIT_CARD
  [PAY_VIA_CREDIT_CARD_REQUEST](state) {
    state.creditCard.isLoading = true
    state.creditCard.isError = false
  },
  [PAY_VIA_CREDIT_CARD_SUCCESS](state) {
    state.creditCard.isLoading = false
    state.creditCard.isError = false
  },
  [PAY_VIA_CREDIT_CARD_FAILURE](state) {
    state.creditCard.isLoading = false
    state.creditCard.isError = true
  },

  // PAY_VIA_QR_CODE
  [PAY_VIA_QR_CODE_REQUEST](state) {
    state.qrcode.isLoading = true
    state.qrcode.isError = false
  },
  [PAY_VIA_QR_CODE_SUCCESS](state, data) {
    state.qrcode.data = data
    state.qrcode.isLoading = false
    state.qrcode.isError = false
  },
  [PAY_VIA_QR_CODE_FAILURE](state) {
    state.qrcode.isLoading = false
    state.qrcode.isError = true
  },

  // QR_VERIFY_SLIP
  [QR_VERIFY_SLIP_REQUEST]() {
    this._vm.$swal({
      title: 'กรุณารอสักครู่',
      html: '<h5 class="m-b-md">กำลังทำการตรวจสอบ</h5><div class="loader"></div>',
      showConfirmButton: false,
      allowOutsideClick: false,
    })
  },
  [QR_VERIFY_SLIP_SUCCESS]() {
    this._vm.$swal.close()
  },
  [QR_VERIFY_SLIP_FAILURE]() {
    this._vm.$swal({
      type: 'error',
      title: 'เกิดข้อผิดพลาดในการตรวจสอบ กรุณาลองใหม่อีกครั้ง',
    })
  },
  updatePaymentFields,
}

const actions = {
  getPaymentInformation({ commit }, applicationId) {
    commit(GET_PAYMENT_INFORMATION_REQUEST)

    Vue.http
      .get(API.PAYMENT.GET_PAYMENT_INFORMATION(applicationId), {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then((res) => res.json())
      .then(
        (res) => commit(GET_PAYMENT_INFORMATION_SUCCESS, res.result.paymentInfo),
        (error) => {
          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return commit(GET_PAYMENT_INFORMATION_FAILURE)

            default:
              return commit(GET_PAYMENT_INFORMATION_FAILURE)
          }
        },
      )
  },
  payViaBillPayment({ commit }, applicationId) {
    commit(PAY_VIA_BILL_PAYMENT_REQUEST)

    Vue.http
      .get(API.PAYMENT.BILL_PAYMENT(applicationId), {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then((res) => res.json())
      .then(
        (res) => commit(PAY_VIA_BILL_PAYMENT_SUCCESS, res.result),
        (error) => {
          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return commit(PAY_VIA_BILL_PAYMENT_FAILURE)

            default:
              return commit(PAY_VIA_BILL_PAYMENT_FAILURE)
          }
        },
      )
  },
  payViaCreditCard({ commit }, data) {
    commit(PAY_VIA_CREDIT_CARD_REQUEST)

    Vue.http
      .post(API.PAYMENT.CREDIT_CARD, data, {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then((res) => res.json())
      .then(
        (res) => {
          commit(PAY_VIA_CREDIT_CARD_SUCCESS)

          return (window.location.href = res.result.authorize_uri)
        },
        (error) => {
          this._vm.$swal.close()

          console.error('payViaCreditCard', error)

          const {
            status,
            body: { message },
          } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
              commit(PAY_VIA_CREDIT_CARD_FAILURE)

              return router.push(
                `/payment/credit-card/failed/${data.applicationId}?reason=${message}`,
              )

            case 500:
              return commit(PAY_VIA_CREDIT_CARD_FAILURE)

            default:
              return commit(PAY_VIA_CREDIT_CARD_FAILURE)
          }
        },
      )

    setTimeout(() => {
      commit(PAY_VIA_CREDIT_CARD_SUCCESS)
    }, 2000)
  },
  payViaQRcode({ commit }, { type, id, socketId }) {
    commit(PAY_VIA_QR_CODE_REQUEST)

    Vue.http
      .get(API.PAYMENT.QRCODE(type, id, socketId), {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then((res) => res.json())
      .then(
        (res) => commit(PAY_VIA_QR_CODE_SUCCESS, res.result.qr),
        (error) => {
          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return commit(PAY_VIA_QR_CODE_FAILURE)

            default:
              return commit(PAY_VIA_QR_CODE_FAILURE)
          }
        },
      )
  },
  verifyQRSlip({ commit }, { qrId, applicationId }) {
    commit(QR_VERIFY_SLIP_REQUEST)

    Vue.http
      .post(
        API.PAYMENT.VERIFY_SLIP,
        { qrid: qrId },
        {
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        },
      )
      .then((res) => res.json())
      .then(
        () => {
          commit(QR_VERIFY_SLIP_SUCCESS)

          return router.push(`/payment/qrcode/success/${applicationId}`)
        },
        (error) => {
          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return commit(QR_VERIFY_SLIP_FAILURE)

            default:
              return commit(QR_VERIFY_SLIP_FAILURE)
          }
        },
      )
  },
  verifyOmiseTokenCreditCard({ commit }, omiseToken) {
    this._vm.$swal({
      title: 'กรุณารอสักครู่',
      html: '<div class="loader"></div>',
      showConfirmButton: false,
      allowOutsideClick: false,
    })

    Vue.http
      .post(
        API.PAYMENT.CREDIT_CARD_VERIFY_TOKEN(omiseToken),
        {},
        {
          headers: {
            ...generateAuthorizationRequestHeader(),
          },
        },
      )
      .then((res) => res.json())
      .then(
        (res) => {
          this._vm.$swal.close()

          return router.push(`/payment/credit-card/success/${res.result.applicationId}`)
        },
        (error) => {
          this._vm.$swal.close()

          const {
            status,
            body: { message },
          } = error

          const { applicationId, reason } = JSON.parse(message)

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
              commit(QR_VERIFY_SLIP_FAILURE)

              return router.push(`/payment/credit-card/failed/${applicationId}?reason=${reason}`)

            case 500:
              return commit(QR_VERIFY_SLIP_FAILURE)

            default:
              return commit(QR_VERIFY_SLIP_FAILURE)
          }
        },
      )
  },
  submitPolicyProcessComplete({ commit }, applicationId) {
    Vue.http
      .get(API.PAYMENT.POLICY_PROCESS_COMPLETE(applicationId), {
        headers: {
          ...generateAuthorizationRequestHeader(),
        },
      })
      .then((res) => res.json())
      .then(
        () => {
          console.log('done')
        },
        (error) => {
          this._vm.$swal.close()

          const { status } = error

          switch (status) {
            case 401:
              this._vm.$session.destroy()

              return (window.location.href = HOMEPAGE_URL)

            case 403:
              return this._vm.$swal({
                type: 'error',
                title: 'ขออภัย ท่านไม่ได้รับสิทธิ์ให้เข้าใช้งานส่วนนี้ได้',
              })

            case 400:
            case 500:
              return console.log('error')

            default:
              return console.log('error')
          }
        },
      )
  },
}

const getters = {
  getPaymentFields,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
